import { render, staticRenderFns } from "./ModalSobre.vue?vue&type=template&id=07afb4d2&"
import script from "./ModalSobre.vue?vue&type=script&lang=js&"
export * from "./ModalSobre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports